const handleUrl = (path, isSubdomain = true) => {
  let url = new URL(document.location.origin);
  if (isSubdomain) url.hostname = `app.${url.hostname.replace('www.', '')}`;
  return `${url.origin}/${path}`;
};

export default handleUrl;
